<div class="discard-changes-dialog" data-testid="discard-changes-dialog">
  <p>{{ 'reports.discardChanges.message' | translate }}</p>
</div>
